import React, { useEffect, useState, useContext} from 'react';
import * as S from './styles';
import {IProps} from './types';
import { IDSConfig, IBrandConfigFont } from '@state/dsconfig/types';
import { useSelector } from 'react-redux';
import { Context } from "routes/private/Editor/Context";
import selectors from '@state/selectors';
import { addFontsFromDSConfig } from '@utils/fonts';

const TIME_BEFORE_CLOSE = 5;

const FontsLoading:React.FC<IProps> = (props) => {
  
  const { editorStatus } = useContext(Context);
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [shouldClose, setShouldClose] = useState(false);
  const [fontsAlreadyLoaded, setFontsAlreadyLoaded] = useState(false);
  const [fonts, setFonts] = useState<IBrandConfigFont[]>([]);

  useEffect(() => {
    if (props.fonts && dsConfig && editorStatus.currentPicker && fontsAlreadyLoaded === false) {
      if (["MultiEditing", "AddNewText", "FontFamily"].includes(editorStatus.currentPicker.toString())) {
        addFontsFromDSConfig(dsConfig);
        setFontsAlreadyLoaded(true);
      }
    }
  }, [editorStatus.currentPicker]);

  useEffect(() => {
    if (dsConfig && props.fonts && props.fonts.length === 0) {
      addFontsFromDSConfig(dsConfig);
    }
  }, [dsConfig])

  useEffect(() => {
    if (props.fonts) {
      if (props.fonts.length !== 0 && fonts.length === 0) {
        setFonts(props.fonts);
        setShouldClose(true);
      } else if (props.fonts.length === 0) {
        setTimeout(() => {
          setShouldClose(false);
        }, TIME_BEFORE_CLOSE * 1000);
      }
    }
  }, [props.fonts])

  return (
    <S.Element
      displayValue={(props.loading && props.fonts !== undefined || shouldClose) ? `block` : `none`}
    >
        <S.ElementMessage>
        <S.TextMessage>
            Loading fonts: 
            <br/>
            {
                fonts.map((font,index) => { return (<div key={"fontLoading" + index} style={{fontFamily: `"font-${font.id}"`}}>{font.name}</div>)})
            }
        </S.TextMessage>
        </S.ElementMessage>
    </S.Element>
  );
}

export default FontsLoading;